import { ref } from 'vue'

export function useListNumberReset(savedList, buildAuthHeaders, refresh) {
  const resetNumbersPending = ref(false)
  const resetNumbersNotice = ref('')

  async function resetNumbers() {
    if (resetNumbersPending.value || !(savedList.value.can_edit ?? savedList.value.is_owner) || !savedList.value.reset_numbers_url) return
    if (!window.confirm('Reset numbers for the entire list? Items will be numbered from 1 without gaps. Their order will stay the same.')) return
    resetNumbersPending.value = true
    resetNumbersNotice.value = ''
    try {
      const response = await fetch(savedList.value.reset_numbers_url, {
        method: 'POST',
        headers: buildAuthHeaders(),
      })
      if (!response.ok) throw new Error('Reset failed')
      await refresh()
      resetNumbersNotice.value = 'Numbers reset.'
    } catch {
      resetNumbersNotice.value = 'Numbers could not be reset. Please try again.'
    } finally {
      resetNumbersPending.value = false
    }
  }

  return { resetNumbersPending, resetNumbersNotice, resetNumbers }
}
